export const LOAD_MEMBER_REQUEST = "LOAD_MEMBER_REQUEST";
export const LOAD_MEMBER_SUCCESS = "LOAD_MEMBER_SUCCESS";
export const LOAD_MEMBER_FAIL = "LOAD_MEMBER_FAIL";


export const CLEAR_ERRORS = "CLEAR_ERRORS";